// extracted by mini-css-extract-plugin
module.exports = {"root":"_3XKS-","logo":"JYSxu","content":"_3vGEI","player":"_1PSOr"};